import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DocumentService } from '@ddt-web/data-service';
import { DcrModule } from '@ddt-web/dcr';
import { DisclosureModule } from '@ddt-web/disclosure';
import { CtaLinkModule } from '@ddt-web/elements';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { FamilyAdditionalResourcesComponent } from './family-additional-resources.component';

@NgModule({
	declarations: [FamilyAdditionalResourcesComponent],
	providers: [DocumentService],
	imports: [
		CommonModule,
		AnalyticsModule,
		CwpNgFrameworkModule,
		DisclosureModule,
		DcrModule,
		SharedModule,
		CtaLinkModule,
		RouterModule.forChild([
			{ path: '', pathMatch: 'full', component: FamilyAdditionalResourcesComponent }
		]),
		GenericDirectivesModule
	]
})
export class FamilyAdditionalResourcesModule { }
